import React, { useEffect, Suspense, lazy } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';

// Lazy loading route components for code splitting & PageSpeed optimization
const Home = lazy(() => import('./pages/Home'));
const LandingPage = lazy(() => import('./pages/LandingPage'));
const LandingPageTrekantsomraadet = lazy(() => import('./pages/LandingPageTrekantsomraadet'));
const Ydelser = lazy(() => import('./pages/Ydelser'));
const PageDetail = lazy(() => import('./pages/PageDetail'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Scroll Restoration Component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Fallback loader while route chunk is loading
function RouteLoader() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center bg-slate-950 text-white">
      <div className="w-8 h-8 border-2 border-[#F1B528] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="relative min-h-screen flex flex-col bg-white text-slate-800 antialiased">
        {/* Premium Navigation Header */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Suspense fallback={<RouteLoader />}>
            <Routes>
              {/* Home Route */}
              <Route path="/" element={<Home />} />

              {/* Dedicated Landing Page (Hidden from navigation menu) */}
              <Route path="/maler-vejle" element={<LandingPage />} />
              <Route path="/malermester-trekantsområdet" element={<LandingPageTrekantsomraadet />} />
              <Route path="/malermester-trekantsomraadet" element={<LandingPageTrekantsomraadet />} />

              {/* Services Overview Page */}
              <Route path="/ydelser" element={<Ydelser />} />

              {/* Service Subpages (under /ydelser/) */}
              <Route path="/ydelser/:slug" element={<PageDetail />} />

              {/* Root-level pages (Om os, Galleri, Lærlinge, Ledige stillinger, Priser, Kontakt, Cases) */}
              <Route path="/:slug" element={<PageDetail />} />

              {/* 404 Not Found Page */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>

        {/* Premium Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
